var Vgr = {
	constants: {},
	filters: {},
	resources: {},
	util: {},
	constructors: {}
};
